<template>
  <div class="animated fadeIn mt-5" v-if="dataLoaded">
    <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event, false)">
      <div class="row">
        <b-col md="6">
          <b-card>
            <div slot="header">
              <strong>Item</strong>
            </div>
            <modal-select modal="dsr-new-modal" v-validate="'required'" name="dsr_id" :readonly="false"
              :item-id="item.dsr_id" :item-name="item.dsr ? item.dsr.data.name : ''" v-on:select-item="selectDsr"
              :state="validateState('dsr_id')" placeholder="DSR" label="DSR"></modal-select>
            <modal-select modal="dsr-new-modal" v-validate="'required'" name="leader_id" :readonly="false"
              :item-id="item.leader_id" :item-name="item.leader ? item.leader.data.name : ''"
              v-on:select-item="selectLeader" :state="validateState('leader_id')" placeholder="Leader"
              label="Leader"></modal-select>


            <b-form-row>
              <b-col md="4">
                <b-form-group description="(AAAA-mm-dd)">
                  <input type="text" v-model="item.date_start" v-mask="'####-##-##'" class="form-control"
                    placeholder="Data de ínicio" />
                </b-form-group>

              </b-col>
              <b-col md="4">
                <b-form-group description="(AAAA-mm-dd)">
                  <input type="text" v-model="item.date_end" v-mask="'####-##-##'" class="form-control"
                    placeholder="Data de fim" />
                </b-form-group>
              </b-col>

            </b-form-row>


            <div slot="footer">

              <!-- Main actions -->
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{ name: 'teams-new.index' }" size="sm" variant="danger">
                    <i class="fa fa-ban"></i>
                    Cancelar
                  </router-link>
                </div>

                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary">
                    <i class="fa fa-save"></i>
                    Gravar
                  </b-button>

                  <b-button type="button" v-on:click="validateBeforeSubmit($event, true)" size="sm" variant="primary"
                    class="ml-2">
                    <i class="fa fa-save"></i>
                    Gravar e fechar
                  </b-button>
                </div>
              </div>


              <!-- Secondary action -->
              <div v-if="item.id && !showNewAssignment" class="row mt-3">
                <div class="col-sm-12 text-right">
                  <b-button type="button" variant="success" @click="createNewAssignment">
                    <i class="fa fa-plus"></i>
                    Adicionar nova relação
                  </b-button>
                </div>
              </div>

            </div>
          </b-card>

          <b-card v-if="showNewAssignment">

            <div slot="header">
              <strong>Item</strong>
            </div>
            <modal-select modal="dsr-new-modal" v-validate="'required'" name="dsr_id" :readonly="false"
              :item-id="newAssignment.dsr_id" :item-name="newAssignment.dsr ? newAssignment.dsr.data.name : ''"
              v-on:select-item="selectDsr" :state="validateState('dsr_id')" placeholder="DSR"
              label="DSR"></modal-select>
            <modal-select modal="dsr-new-modal" v-validate="'required'" name="leader_id" :readonly="false"
              :item-id="newAssignment.leader_id" :item-name="newAssignment.leader ? newAssignment.leader.data.name : ''"
              v-on:select-item="selectLeader" :state="validateState('leader_id')" placeholder="Leader"
              label="Leader"></modal-select>


            <b-form-row>
              <b-col md="4">
                <b-form-group description="(AAAA-mm-dd)">
                  <input type="text" v-model="newAssignment.date_start" v-mask="'####-##-##'" class="form-control"
                    placeholder="Data de ínicio" />
                </b-form-group>

              </b-col>
              <b-col md="4">
                <b-form-group description="(AAAA-mm-dd)">
                  <input type="text" v-model="newAssignment.date_end" v-mask="'####-##-##'" class="form-control"
                    placeholder="Data de fim" />
                </b-form-group>
              </b-col>

            </b-form-row>

            <div slot="footer">
              <div class="row">
                <div class="col-sm-3">
                  <router-link :to="{ name: 'teams-new.index' }" size="sm" variant="danger">
                    <i class="fa fa-ban"></i>
                    Cancelar
                  </router-link>
                </div>

                <div class="col-sm-9 text-right">
                  <b-button type="submit" size="sm" variant="primary">
                    <i class="fa fa-save"></i>
                    Gravar
                  </b-button>

                  <b-button type="button" v-on:click="validateBeforeSubmit($event, true)" size="sm" variant="primary"
                    class="ml-2">
                    <i class="fa fa-save"></i>
                    Gravar e fechar
                  </b-button>
                </div>
              </div>

              <div v-if="item.id && !showNewAssignment" class="row mt-3">
                <div class="col-sm-12 text-right">
                  <b-button type="button" variant="success" @click="createNewAssignment">
                    <i class="fa fa-plus"></i>
                    Adicionar nova relação
                  </b-button>
                </div>
              </div>
            </div>
          </b-card>


        </b-col>

        <!--/.col-->
      </div>
    </form>

  </div>
</template>

<script>

import Zones from '@/views/dealers/zones/modal.vue'
export default {
  name: 'BestofDsrObjectiveEdit',
  props: ['id'],
  components: { Zones },
  data() {
    return {
      dataLoaded: false,
      modalType: '',
      showModal: false,
      item: {
        dsr_id: null,
        dsr: { data: {} },
        leader_id: null,
        leader: { data: {} },
        date_start: '',
        date_end: null
      },
      showNewAssignment: false,
      newAssignment: {
        dsr_id: null,
        dsr: { data: {} },
        leader_id: null,
        leader: { data: {} },
        date_start: '',
        date_end: null
      }
    }
  },
  methods: {
    selectDsr(e) {
      this.item.dsr_id = e.item.id
      this.item.dsr.data = e.item
    },
    selectLeader(e) {
      if (this.showNewAssignment) {
        this.newAssignment.leader_id = e.item.id;
        this.newAssignment.leader.data = e.item;
      } else {
        this.item.leader_id = e.item.id;
        this.item.leader.data = e.item;
      }
    },
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },

    createNewAssignment() {

      if (!this.item.date_end) {
        this.$bvToast.toast(
          'Para adicionar uma nova relação deve primeiro preencher a Data de fim da relação atual.',
          {
            autoHideDelay: 6000,
            variant: 'warning',
            solid: true
          }
        );
        return;
      }

      this.showNewAssignment = true;

      this.newAssignment = {
        dsr_id: this.item.dsr_id,
        dsr: JSON.parse(JSON.stringify(this.item.dsr)),
        leader_id: null,
        leader: { data: {} },
        date_start: '',
        date_end: null
      };
    },
    submit(e, close) {

      e.preventDefault();

      /*
       * CREATE
       */
      if (!this.item.id) {

        this.axios.post(
          'teamsnew',
          {
            data: this.item
          }
        )
          .then(response => {

            this.item = response.data.data;

            this.$bvToast.toast(
              'Item gravado com sucesso',
              {
                autoHideDelay: 5000,
                variant: 'success',
                solid: true
              }
            );

            if (close) {
              this.$router.push({
                name: 'teams-new.index'
              });
            } else {
              this.$router.push({
                name: 'teams-new.edit',
                params: {
                  id: this.item.id
                }
              });
            }

          })
          .catch(() => {

            this.$bvToast.toast(
              'Não foi possível gravar',
              {
                autoHideDelay: 5000,
                variant: 'danger',
                solid: true
              }
            );

          });

        return;
      }

      /*
       * NORMAL EDIT
       */
      if (!this.showNewAssignment) {
        this.axios.put(
          'teamsnew/' + this.item.id,
          {
            data: this.item
          }
        )
          .then(response => {
            this.item = response.data.data;
            this.$bvToast.toast(
              'Item gravado com sucesso',
              {
                autoHideDelay: 5000,
                variant: 'success',
                solid: true
              }
            );

            if (close) {
              this.$router.push({
                name: 'teams-new.index'
              });
            }
          })
          .catch(() => {
            this.$bvToast.toast(
              'Não foi possível gravar',
              {
                autoHideDelay: 5000,
                variant: 'danger',
                solid: true
              }
            );
          });

        return;
      }

      /*
       * CHANGE LEADER
       */
      if (!this.item.date_end) {
        this.$bvToast.toast(
          'A Data de fim da relação atual é obrigatória para criar uma nova relação.',
          {
            autoHideDelay: 6000,
            variant: 'warning',
            solid: true
          }
        );
        return;
      }

      if (!this.newAssignment.leader_id) {
        this.$bvToast.toast(
          'Selecione o novo líder.',
          {
            autoHideDelay: 6000,
            variant: 'warning',
            solid: true
          }
        );
        return;
      }

      if (!this.newAssignment.date_start) {
        this.$bvToast.toast(
          'Indique a Data de início da nova relação.',
          {
            autoHideDelay: 6000,
            variant: 'warning',
            solid: true
          }
        );
        return;
      }

      const data = {
        data: {
          date_end: this.item.date_end,
          new_leader_id: this.newAssignment.leader_id,
          new_date_start: this.newAssignment.date_start,
          new_date_end: this.newAssignment.date_end
        }
      };

      this.axios.post(
        'teamsnew/' + this.item.id + '/change-leader',
        data
      )
        .then(() => {
          this.$bvToast.toast(
            'Nova relação criada com sucesso',
            {
              autoHideDelay: 5000,
              variant: 'success',
              solid: true
            }
          );

          if (close) {
            this.$router.push({
              name: 'teams-new.index'
            });
          } else {
            this.showNewAssignment = false;
            this.axios.get('teamsnew/' + this.item.id)
              .then(response => {
                this.item = response.data.data;
              });
          }
        })
        .catch(() => {

          this.$bvToast.toast(
            'Não foi possível alterar o líder',
            {
              autoHideDelay: 5000,
              variant: 'danger',
              solid: true
            }
          );
        });
    },
  },

  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('teamsnew' + '/' + id)
        .then(response => {
          this.item = response.data.data
          this.dataLoaded = true
        })
        .catch(response => {
          this.$bvToast.toast(`Este item não existe`, { autoHideDelay: 5000, variant: 'danger', solid: true })
          this.$router.push({
            name: 'teams-new.index'
          })
        })
    } else {
      this.dataLoaded = true
    }
  }
}
</script>
